import { GeneralSettingMapper } from '../../mappers';
import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { IUpdateGeneralSettingsUseCase, GeneralSetting, UIAdaptedGeneralSetting } from '../../interfaces';

/**
 * ### Update General Settings
 *
 * Use Case for update the a club user preferences like:
 * - theme
 * - language
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class UpdateGeneralSettingsUseCase extends HttpPostRequest<GeneralSetting, GeneralSetting> implements IUpdateGeneralSettingsUseCase {
  public async execute(payload: UIAdaptedGeneralSetting): Promise<UIAdaptedGeneralSetting> {
    const response = await this.dispatch('/setting', GeneralSettingMapper.fromUIToBackend(payload));
    this.expireEndpoint('/setting');
    return GeneralSettingMapper.fromBackendToUI(response.data.data);
  }
}
